module.exports = __webpack_public_path__ + "img/icon_qingpai_logo_n.e6e9cdaa.png";